import React, { useContext, useEffect, useState } from "react";
import "../../styles/Navbar.css";
import Logo from "../../assets/header/sustainathon-logo.png";
import Toggler from "../../assets/header/menutoggler.png";
import { NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Navi = () => {
  window.onscroll = function () {
    scrollFunction();
  };
  const { language, setLanguages, setLanguage } = useContext(LanguageContext);
  const { pathname } = useLocation();
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
      // -- setting new languages
      if (!pathname.includes("/events/")) {
        setLanguages({ ENGLISH: "English", ARABIC: "Arabic" });
        // setLanguage("English")
      }
    }
  }, [pathname]);

  // run this function from an event handler or an effect to execute scroll
  return (
    <div className="head">
      <header id="main-header" className="" style={{ top: "0px" }}>
        <div className="head-container clearfix et_menu_container">
          <div className="logo_container">
            <span className="logo_helper"></span>
            <NavLink exact to="/">
              <img
                className="img-fluid"
                id="tcs_logo"
                loading="lazy"
                src={Logo}
                alt="TCS Sustainathon"
              />
            </NavLink>
          </div>
          <div
            id="et-top-navigation"
            style={{ paddingLeft: "203px" }}
            data-height="87"
            data-fixed-height="30"
          >
            <nav id="top-menu-nav">
              <ul id="top-menu" className="nav">
                <li
                  id="menu-item-227"
                  className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-227"
                >
                  <NavLink exact to="/" activeClassName="selected">
                    {TEXT[language]["NAVBAR"]["0"]}
                  </NavLink>
                </li>
                <li
                  id="menu-item-226"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-226"
                >
                  <NavLink to="/events" activeClassName="selected">
                    {TEXT[language]["NAVBAR"]["1"]}
                  </NavLink>
                </li>
                <li
                  id="menu-item-225"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-225"
                >
                  <LanguageButtonDropdown />
                </li>
              </ul>
            </nav>
            <div id="et_mobile_nav_menu">
              <div className="mobile_nav closed">
                <span className="select_page">
                  {TEXT[language]["NAVBAR"]["2"]}
                </span>
                <span
                  className="mobile_menu_bar mobile_menu_bar_toggle"
                  onClick={myFunction}
                >
                  <img
                    alt="toggler"
                    width="30"
                    height="auto"
                    src={Toggler}
                    ait="icon"
                  />
                </span>
                <ul
                  id="mobile_menu"
                  className="et_mobile_menu"
                  style={{ display: "none" }}
                >
                  <li
                    id="menu-item-227"
                    className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-227 et_first_mobile_item"
                  >
                    <NavLink exact to="/" activeClassName="selected">
                      {TEXT[language]["NAVBAR"]["0"]}
                    </NavLink>
                  </li>
                  <li
                    id="menu-item-226"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-226"
                  >
                    <NavLink to="/events" activeClassName="selected">
                      {TEXT[language]["NAVBAR"]["1"]}
                    </NavLink>
                  </li>
                  <li
                    id="menu-item-225"
                    className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-225 et_first_mobile_item"
                  >
                    <a>
                      <LanguageButtonDropdown />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* ------------ langauge selection -------------- */}
        </div>
      </header>
    </div>
  );
};

export default Navi;

function LanguageButtonDropdown() {
  const { language, setLanguage, languages } = useContext(LanguageContext);
  const hide = false; // location?.pathname.includes("/events/");

  if (hide) {
    return <></>;
  } else {
    return (
      <Dropdown>
        <Dropdown.Toggle
          variant="outline-secondary"
          id="dropdown-basic dropdown-autoclose-true"
          size="sm"
          className="dropdown-toggle"
        >
          {languages[language]}
        </Dropdown.Toggle>
        <Dropdown.Menu variant="outline-primary" className="dropdown-menu">
          {Object.entries(languages).map(([key, value]) => (
            <Dropdown.Item
              onClick={() => setLanguage(key)}
              key={key}
              className="dropdown-bootstrap-item"
            >
              {value}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

function myFunction() {
  var x = document.getElementById("mobile_menu");
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
}

function scrollFunction() {
  var element = document.getElementById("main-header");
  var element2 = document.getElementById("tcs_logo");
  if (element && element2) {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      if (!element.classList.contains("new-scroll-header")) {
        element.classList.add("new-scroll-header");
        element2.style.display = "none";
      }
    } else {
      if (element.classList.contains("new-scroll-header")) {
        element.classList.remove("new-scroll-header");
        element2.style.display = "";
      }
    }
  }
}
